import type { Middleware } from '@reduxjs/toolkit';
import type { RootState } from '..';

const arrayMiddleware: Middleware<object, RootState> =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (Array.isArray(action)) {
      return action.map(dispatch);
    }

    return next(action);
  };

export default arrayMiddleware;
